<template>
  <MainBody />
  
</template>

<script setup name="WomuMain">
import MainBody from '@/components/MainBody.vue'
import { onMounted } from 'vue';
onMounted(() => {
  window.scrollTo(0, 0);
})
</script>

<style scoped>

</style>